import { render, staticRenderFns } from "./SolicitudMttoComponent.vue?vue&type=template&id=53db2b61&"
import script from "./SolicitudMttoComponent.vue?vue&type=script&lang=js&"
export * from "./SolicitudMttoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports